import React from 'react';
import {
  FaBullseye,
  FaEye,
  FaLightbulb,
  FaShieldAlt,
  FaHandshake,
  FaCogs,
  FaUsers,
  FaRocket,
} from 'react-icons/fa';
import './About.css';

function About() {
  return (
    <div className="about_container">

      {/* Intro + Mission/Vision */}
      <div className="intro_mission_wrapper">
        {/* Left - Intro */}
        <div className="about_intro">
          <h1>Hiten Technologies</h1>
          <h3>
            Hiten Technologies is a full-stack software development and IT consulting company committed to building digital products that drive business value.
            Founded with a vision to combine creativity, technology, and strategy — we create intelligent solutions that empower global organizations.
          </h3>
          <h3 className="philosophy">
            Our philosophy <br />
            <span>Think. Build. Innovate. Deliver.</span>
          </h3>
          <p>
            We’re more than coders — we’re digital architects. From concept to launch, we build
            solutions that streamline operations, enhance customer experience, and accelerate
            business growth. Our cross-functional team blends strategy, design, and engineering
            to bring your vision to life.
          </p>
        </div>

        {/* Right - Mission & Vision */}
        <div className="mission_vision_cards">
          <div className="card mission">
            <FaBullseye className="card_icon" />
            <h2>Our Mission</h2>
            <small>Empowering businesses through smart tech.</small>
            <p>
              To simplify technology adoption through innovative, scalable, and affordable digital
              solutions — enabling our clients to thrive in a digital-first world.
            </p>
          </div>

          <div className="card vision">
            <FaEye className="card_icon" />
            <h2>Our Vision</h2>
            <small>Inspiring the future of digital transformation.</small>
            <p>
              To be recognized globally as a leader in IT innovation — transforming industries and
              enriching user experiences through world-class technology and service excellence.
            </p>
          </div>
        </div>
      </div>

      {/* Core Values */}
      <div className="core_values">
        <h2>Our Core Values</h2>
        <div className="values_grid">
          <div className="value_card">
            <FaLightbulb className="value_icon" />
            <div>
              <strong>Innovation</strong>
              <p>Embracing creative solutions to solve complex challenges.</p>
            </div>
          </div>
          <div className="value_card">
            <FaShieldAlt className="value_icon" />
            <div>
              <strong>Integrity</strong>
              <p>Building trust through transparency and ethics.</p>
            </div>
          </div>
          <div className="value_card">
            <FaHandshake className="value_icon" />
            <div>
              <strong>Client-Centric</strong>
              <p>Partnering closely to ensure your success.</p>
            </div>
          </div>
          <div className="value_card">
            <FaCogs className="value_icon" />
            <div>
              <strong>Excellence</strong>
              <p>Delivering superior quality solutions that exceed expectations.</p>
            </div>
          </div>
          <div className="value_card">
            <FaUsers className="value_icon" />
            <div>
              <strong>Collaboration</strong>
              <p>Working together for shared success.</p>
            </div>
          </div>
          <div className="value_card">
            <FaRocket className="value_icon" />
            <div>
              <strong>Continuous Growth</strong>
              <p>Always learning, improving, and pushing boundaries.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
